import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { HiOutlineArrowsPointingOut } from 'react-icons/hi2';
import { cn } from '../../../helpers/utils/css-utils';

export const PopoverButton = ({ option, eventTrigger, onDragStart }) => {
  const { id, title, icon: Icon, nodes = [], event, clickOnly } = option;
  const [showNodes, setShowNodes] = useState(false);

  const hasMenu = nodes?.length > 0;

  return (
    <div
      className="group relative"
      onMouseEnter={() => setShowNodes(true)}
      onMouseLeave={() => setShowNodes(false)}
    >
      <button
        id={id}
        type="button"
        title={title}
        className={cn(
          `flex h-[52px] w-[62px] flex-col items-center justify-center gap-1 rounded-lg px-1
           transition-all duration-200 ease-out active:scale-95
           hover:bg-gray-100
           focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1`,
          { 'bg-gray-100': showNodes && hasMenu }
        )}
        onClick={() => eventTrigger(event)}
      >
        <Icon className="h-[18px] w-[18px] shrink-0 text-gray-600 transition-colors duration-200 group-hover:text-primary" />
        <span className="w-full truncate text-center text-[11px] font-medium leading-none text-gray-600 transition-colors duration-200 group-hover:text-primary">
          {title}
        </span>
      </button>

      {/* Node list */}
      {hasMenu && (
        <div className="absolute left-1/2 top-full z-50 hidden -translate-x-1/2 pt-2 group-hover:block">
          <ul
            id={`${id}-node`}
            aria-label="node list"
            className="flex w-64 flex-col gap-0.5 overflow-hidden rounded-xl border border-gray-200 bg-white p-1.5
              shadow-xl shadow-gray-300/40 dark:shadow-black/50"
          >
            {nodes.map(({ id: nodeType, text, icon: NodeIcon, defaultConfig }, index) => (
              <li
                key={index}
                className="group/item flex cursor-grab select-none items-center gap-3 rounded-lg px-3 py-2.5
                  text-gray-700 transition-colors duration-150 hover:bg-gray-100 active:cursor-grabbing active:scale-[0.98]"
                onClick={() => {
                  if (clickOnly) {
                    eventTrigger(nodeType);
                  }
                }}
                onDragStart={(event) => onDragStart(event, {
                  label: text,
                  nodeType,
                  stateConfig: defaultConfig
                })}
                draggable
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-600 transition-colors duration-150 group-hover/item:bg-white group-hover/item:text-primary dark:group-hover/item:bg-gray-800 dark:group-hover/item:text-white">
                  <NodeIcon className="h-4 w-4" />
                </span>
                <span className="truncate text-sm font-medium">{text}</span>
              </li>
            ))}

            {!clickOnly && (
              <li className="mt-1 flex items-center gap-2 border-t border-gray-100 px-3 pb-1 pt-2.5">
                <HiOutlineArrowsPointingOut className="h-3.5 w-3.5 shrink-0 text-gray-400" />
                <span className="text-[11px] leading-tight text-gray-400">
                  Drag onto the canvas to add a step
                </span>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

PopoverButton.propTypes = {
  option: PropTypes.object,
  eventTrigger: PropTypes.func,
  onDragStart: PropTypes.func,
};
